import Importer from './Importer';

export default {
  importer: [ 'type', Importer ]
};